/**
 * Utilidades compartidas de validación y normalización de URLs del CV Creator.
 * Consumidas por cv-creator.js y cv-creator-premium.js vía Grunt concat.
 */
(function (global) {
    'use strict';

    /**
     * Host tal como lo escribe el usuario (sin normalizar a IPv4 decimal).
     * Evita que "21312321" pase como válido: el parser la convierte en 1.69.51.65.
     */
    function cvcreatorPortfolioRawHostString(raw) {
        var s = (raw === undefined || raw === null) ? '' : String(raw).trim();
        if (s === '') {
            return '';
        }
        s = s.replace(/^https?:\/\//i, '');
        var authority = s.split('/')[0].split('?')[0].split('#')[0];
        var hostport = authority.indexOf('@') !== -1 ? authority.split('@').pop() : authority;
        if (hostport.indexOf('[') === 0) {
            return '';
        }
        var host = hostport;
        var colonIdx = hostport.lastIndexOf(':');
        if (colonIdx !== -1 && hostport.indexOf('.') !== -1) {
            host = hostport.slice(0, colonIdx);
        } else if (colonIdx !== -1 && hostport.indexOf('.') === -1) {
            var parts = hostport.split(':');
            if (parts.length === 2 && /^\d+$/.test(parts[1])) {
                host = parts[0];
            }
        }
        return host;
    }

    /**
     * Exige dominio con TLD (ej. .com, .mx, .io). Rechaza "hola", "hola." sin dominio real.
     */
    function cvcreatorHostnameHasValidTld(hostname) {
        var hostRaw = String(hostname || '');
        if (/\.+$/.test(hostRaw)) {
            return false;
        }
        var h = hostRaw.replace(/\.+$/g, '');
        if (h === 'localhost') {
            return true;
        }
        if (/^\d{1,3}(\.\d{1,3}){3}$/.test(h)) {
            return true;
        }
        if (h.indexOf(':') !== -1) {
            return true;
        }
        var normalizedHost = h.replace(/^www\./i, '');
        var parts = normalizedHost.split('.').filter(function (p) {
            return p.length > 0;
        });
        if (parts.length < 2) {
            return false;
        }
        var tld = parts[parts.length - 1];
        if (tld.length < 2) {
            return false;
        }
        return /^[a-z0-9]{2,63}$/i.test(tld);
    }

    /**
     * Validación de URLs de enlaces profesionales (portfolio).
     * Vacío = válido (sin error). Texto no vacío debe ser una URL http(s) con host reconocible.
     */
    function cvcreatorIsValidPortfolioUrl(raw) {
        var v = (raw === undefined || raw === null) ? '' : String(raw).trim();
        if (v === '') {
            return true;
        }
        var rawHost = cvcreatorPortfolioRawHostString(v);
        if (rawHost !== '' && /^\d+$/.test(rawHost)) {
            return false;
        }
        var candidate = v;
        if (!/^https?:\/\//i.test(candidate)) {
            candidate = 'https://' + candidate;
        }
        try {
            var u = new URL(candidate);
            if (u.protocol !== 'http:' && u.protocol !== 'https:') {
                return false;
            }
            var h = u.hostname;
            return cvcreatorHostnameHasValidTld(h);
        } catch (err) {
            return false;
        }
    }

    /**
     * Normaliza texto libre a URL válida:
     * - URL http(s) válida: se conserva tal cual (trim).
     * - Texto plano/sin protocolo: se transforma a https://www.<valor>.com
     */
    function cvcreatorNormalizeUrlValue(raw) {
        var v = (raw === undefined || raw === null) ? '' : String(raw).trim();
        if (v === '') {
            return '';
        }
        if (/^https?:\/\//i.test(v) && cvcreatorIsValidPortfolioUrl(v)) {
            return v;
        }
        v = v.replace(/^https?:\/\//i, '');
        v = v.replace(/^www\./i, '');

        var candidates = v.match(/[a-z0-9-]+(?:\.[a-z0-9-]+)*/gi) || [];
        var authority = '';
        var i;
        for (i = candidates.length - 1; i >= 0; i--) {
            var token = String(candidates[i] || '').replace(/^www\./i, '').replace(/\.+$/g, '');
            if (token.indexOf('.') !== -1) {
                authority = token;
                break;
            }
            if (authority === '') {
                authority = token;
            }
        }

        authority = authority.replace(/^\.+|\.+$/g, '');
        var labels = authority.split('.').filter(function (label) {
            return label !== '';
        });
        var cleanedLabels = [];
        var li;
        for (li = 0; li < labels.length; li++) {
            var lbl = String(labels[li] || '').toLowerCase();
            lbl = lbl.replace(/^(?:https?|www)+/i, '');
            if (lbl === '') {
                continue;
            }
            cleanedLabels.push(lbl);
        }
        if (cleanedLabels.length === 0) {
            authority = '';
        } else if (cleanedLabels.length === 1) {
            authority = cleanedLabels[0] + '.com';
        } else {
            var tld = cleanedLabels[cleanedLabels.length - 1];
            if (!/^[a-z0-9]{2,63}$/i.test(tld)) {
                cleanedLabels[cleanedLabels.length - 1] = 'com';
            }
            authority = cleanedLabels.join('.');
        }
        if (authority === '') {
            return '';
        }
        return 'https://www.' + authority;
    }

    /**
     * Tiempo restante hasta endtime (ms). nowDate opcional para tests deterministas.
     */
    function cvcreatorGetTimeRemaining(endtime, nowDate) {
        var now = nowDate ? Date.parse(nowDate) : Date.parse(new Date());
        var t = Date.parse(endtime) - now;
        var seconds = Math.floor((t / 1000) % 60);
        var minutes = Math.floor((t / 1000 / 60) % 60);
        var hours = Math.floor((t / (1000 * 60 * 60)) % 24);
        var days = Math.floor(t / (1000 * 60 * 60 * 24));
        return {
            total: t,
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        };
    }

    /** Parsea retry_after del server con fallback (DEO-366). */
    function cvcreatorParseRetryAfter(data, defaultSeconds) {
        var fallback = defaultSeconds || 120;
        if (!data || data.retry_after === undefined || data.retry_after === null) {
            return fallback;
        }
        var parsed = parseInt(data.retry_after, 10);
        return isNaN(parsed) || parsed < 0 ? fallback : parsed;
    }

    /** Formatea MM:SS para el countdown del PIN. */
    function cvcreatorFormatPinCountdown(totalSeconds) {
        var seconds = Math.max(0, parseInt(totalSeconds, 10) || 0);
        var mm = ('0' + Math.floor(seconds / 60)).slice(-2);
        var ss = ('0' + (seconds % 60)).slice(-2);
        return { minutes: mm, seconds: ss };
    }

    /** Indica si el timer debe mostrar el enlace "Solicitar nuevo PIN". */
    function cvcreatorShouldShowRequestNewPin(minutes, seconds) {
        return minutes <= 0 && seconds <= 0;
    }

    /**
     * Controlador de intervalo del reloj PIN — evita acumular setInterval (DEO-366).
     * clearIntervalFn/setIntervalFn inyectables para tests.
     */
    function cvcreatorCreatePinClockController(clearIntervalFn, setIntervalFn) {
        var clockInterval = null;
        var clearFn = clearIntervalFn || clearInterval;
        var setFn = setIntervalFn || setInterval;

        return {
            start: function (updateFn, intervalMs) {
                if (clockInterval !== null) {
                    clearFn(clockInterval);
                }
                updateFn();
                clockInterval = setFn(updateFn, intervalMs || 1000);
            },
            stop: function () {
                if (clockInterval !== null) {
                    clearFn(clockInterval);
                    clockInterval = null;
                }
            },
            getIntervalId: function () {
                return clockInterval;
            }
        };
    }

    var utils = {
        cvcreatorPortfolioRawHostString: cvcreatorPortfolioRawHostString,
        cvcreatorHostnameHasValidTld: cvcreatorHostnameHasValidTld,
        cvcreatorIsValidPortfolioUrl: cvcreatorIsValidPortfolioUrl,
        cvcreatorNormalizeUrlValue: cvcreatorNormalizeUrlValue,
        cvcreatorGetTimeRemaining: cvcreatorGetTimeRemaining,
        cvcreatorParseRetryAfter: cvcreatorParseRetryAfter,
        cvcreatorFormatPinCountdown: cvcreatorFormatPinCountdown,
        cvcreatorShouldShowRequestNewPin: cvcreatorShouldShowRequestNewPin,
        cvcreatorCreatePinClockController: cvcreatorCreatePinClockController
    };

    if (typeof module === 'object' && module.exports) {
        module.exports = utils;
    }

    if (global) {
        global.cvcreatorPortfolioRawHostString = cvcreatorPortfolioRawHostString;
        global.cvcreatorHostnameHasValidTld = cvcreatorHostnameHasValidTld;
        global.cvcreatorIsValidPortfolioUrl = cvcreatorIsValidPortfolioUrl;
        global.cvcreatorNormalizeUrlValue = cvcreatorNormalizeUrlValue;
        global.cvcreatorGetTimeRemaining = cvcreatorGetTimeRemaining;
        global.cvcreatorParseRetryAfter = cvcreatorParseRetryAfter;
        global.cvcreatorFormatPinCountdown = cvcreatorFormatPinCountdown;
        global.cvcreatorShouldShowRequestNewPin = cvcreatorShouldShowRequestNewPin;
        global.cvcreatorCreatePinClockController = cvcreatorCreatePinClockController;
    }
}(typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : this));
